__turbopack_context__.v({
  "currentPrice": "_3xeIPG_currentPrice",
  "lastThirtyDaysPrice": "_3xeIPG_lastThirtyDaysPrice",
  "price": "_3xeIPG_price",
  "priceBeforeDiscount": "_3xeIPG_priceBeforeDiscount",
  "priceLabel": "_3xeIPG_priceLabel",
  "pricePerGrammar": "_3xeIPG_pricePerGrammar",
  "prices": "_3xeIPG_prices",
  "pricesWrapper": "_3xeIPG_pricesWrapper",
});
